"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetTemplateTransformedForCurrentUser = void 0;
var _react = require("react");
var _sdk = require("../../../sdk");
var _common = require("../../input-field-components/ProjectMemberDropdown/common");
var _currentUserPermissions = require("../../state/redux/ducks/currentUserPermissions");
var _issueRootCauses = require("../../state/redux/ducks/issueRootCauses");
var _hooks = require("../../state/redux/hooks");
var _useSelectedOption = require("./useSelectedOption");
const useGetIsValidAssigneeOxygenId = () => {
  const permittedActions = (0, _hooks.useSelector)(_currentUserPermissions.getCurrentUserPermittedActionsForNewIssue);
  const levelOneUserShouldIncludeMemberFn = (0, _common.useGetLevelOneUserShouldIncludeMemberFn)();
  const shouldIncludeMemberFn = !permittedActions.includes(_sdk.PermittedAction.AssignAll) ? levelOneUserShouldIncludeMemberFn : undefined;
  const groupedOptions = (0, _common.useGroupedProjectMembersAsOptions)({
    shouldIncludeMemberFn,
    shouldIncludeEmpty: true
  });
  // get an object with all valid assignees as keys.
  // faster than checking a list when there are tons of options,
  // and easier to debug than a Set
  const validOxygenIdMap = (0, _react.useMemo)(() => {
    const validOptionIds = {};
    const flatOptions = (0, _useSelectedOption.getFlatOptions)(groupedOptions);
    flatOptions.forEach(option => {
      validOptionIds[option.value] = true;
    });
    return validOptionIds;
  }, [groupedOptions]);
  const getIsValidAssigneeOxygenId = oxygenId => {
    return !!validOxygenIdMap[oxygenId];
  };
  return {
    getIsValidAssigneeOxygenId
  };
};

/**
 *
 * The template refers to uids of certain objects which may or may not be active, or may be deleted,
 * or the current user may not have permission to access.
 *
 * For those objects, we do not want them to affect the attributes of issues created from the template.
 *
 * This applies to root cause and assignee, in particular
 *
 * (note that since type is required, we do not try to modify it... templates with inactive types will still be created)
 */
const useGetTemplateTransformedForCurrentUser = () => {
  const rootCauseEntitiesMap = (0, _hooks.useSelector)(_issueRootCauses.getIssueRootCausesEntitiesMap);
  const {
    getIsValidAssigneeOxygenId
  } = useGetIsValidAssigneeOxygenId();
  const getTemplateTransformedForCurrentContext = _ref => {
    let {
      template
    } = _ref;
    let transformedTemplate = {
      ...template
    };
    if (transformedTemplate.issueAttributes.rootCauseId) {
      const rootCause = rootCauseEntitiesMap[transformedTemplate.issueAttributes.rootCauseId];
      if (!rootCause || !rootCause.isActive) {
        // this object is treated as read only in typescript so we need to re-create it.
        transformedTemplate = {
          ...transformedTemplate,
          issueAttributes: {
            ...transformedTemplate.issueAttributes,
            rootCauseId: undefined
          }
        };
      }
    }
    if (transformedTemplate.issueAttributes.assigneeId) {
      const isAssigneeValid = getIsValidAssigneeOxygenId(transformedTemplate.issueAttributes.assigneeId);
      if (!isAssigneeValid) {
        transformedTemplate = {
          ...transformedTemplate,
          issueAttributes: {
            ...transformedTemplate.issueAttributes,
            assigneeId: undefined,
            assignedToType: undefined
          }
        };
      }
    }
    return transformedTemplate;
  };
  return getTemplateTransformedForCurrentContext;
};
exports.useGetTemplateTransformedForCurrentUser = useGetTemplateTransformedForCurrentUser;
//# sourceMappingURL=useGetTemplateTransformedForCurrentUser.js.map